export default {
  'Custom': 'Cамоопределение',
  'Original': 'Оригинал',
  'Resolution': 'Разрешение',
  'Frame rate': 'Частота кадров',
  'The higher the frame rate, the smoother the animation': 'Чем выше частота кадров, тем плавнее анимация.',
  'Start': 'Start',
  'End': 'Конец',
  'Create GIF': 'Создать GIF',
  'Download GIF': 'Скачать GIF',
  'Create A New One': 'Создайте Новый',
  'Remake GIF': 'Переделать GIF',
  'HitPaw Video to GIF Online': 'HitPaw Видео в GIF Онлайн',
  'Upload and convert video to GIF without any difficulty': 'Загружайте и конвертируйте видео в GIF без никаких проблем.',
}